<template>
  <div class="invitation_page">
    <!-- 表单 -->
    <div class="forms_box">
      <div class="home_phone">
        <div class="form-box">
          <div class="input_text">
            <div class="input_wrap">
              <input
                class="inputphone"
                type="number"
                oninput="if(value.length>11)value=value.slice(0,11)"
                v-model="mobile"
                @focus="handleOnFocus"
                @blur="handleOnBlur"
                placeholder="输入您的手机号码"
              />
            </div>
          </div>
          <div class="input_text1">
            <div class="inputBox inputBox1">
              <input
                type="text"
                maxlength="4"
                v-model="imgCode"
                @focus="handleOnFocus"
                @blur="handleOnBlur"
                placeholder="输入验证码"
              />
            </div>
            <span>
              <img :src="imgCodeSrc" @click="handleUpdateImgCode()" />
            </span>
          </div>
          <div class="input_text1 input_text2">
            <div class="inputBox">
              <input
                type="text"
                maxlength="6"
                v-model="mobileCode"
                @focus="handleOnFocus"
                @blur="handleOnBlur"
                placeholder="输入短信验证码"
              />
            </div>
            <span
              @click="sendSMS()"
              :style="!this.sendCodeActivity && { opacity: 0.5 }"
              >{{ sendCodeText }}</span
            >
          </div>
          <!-- 提交按钮 -->
          <div class="sumbit" @click="sendInfo"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { openService } from "@/utils/common";

// import {
//   pageBuryingPoint,
//   eventBuryingPoint,
//   DestructyBuryingPoint
// } from "@/utils/BuryingPoint";
import fetch from "@/utils/fetch";

import { showToast, pageRecord } from "@/utils/h5";

export default {
  name: "HomePage",
  data() {
    return {
      subCode: "lcj_lottery",
      key: this.$root.key,
      loginFlag: this.$root.loginFlag, //登陆状态
      accountNo: "",
      mobile: "", // 手机号码,校验抽奖身份
      imgCode: "", // 图形验证码
      mobileCode: "", // 短信验证码
      imgCodeSrc: "", // 图形验证码
      sendCodeText: "获取验证码",
      sendCodeActivity: true, // 发送验证码按钮是否可点击
      submitFlag: true, // 提交按钮是否可点击
      codes: "", //邀请码
    };
  },

  created() {
    pageRecord("tjjdwjdc"); //增加页面访问记录
    var that = this;
    if (window.location.href.indexOf("code") > -1) {
      var arr = window.location.href.split("?")[1].split("&");
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].indexOf("code") > -1) {
          that.codes = arr[i].split("=")[1];
        }
      }
    }
    that.handleUpdateImgCode(); //图形验证码
    if (window.history && window.history.pushState) {
      // alert(document.URL)
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.backChange, false); //false阻止默认事件
    }
    // $("html,body").css("overflow", "hidden").css("height", "100%");
    document.body.addEventListener(
      "touchmove",
      self.welcomeShowedListener,
      false
    );
  },
  beforeDestroy() {
    //页面销毁前
    // DestructyBuryingPoint("p_ytwxhlqq_01");
  },
  mounted() {},
  methods: {
    // 发送手机验证码
    sendSMS() {
      var that = this;
      if (that.handleValidate("mobile")) {
        if (!that.handleValidate("imgCode"))
          return showToast({
            message: "请填写正确的图形验证码",
            duration: 2000,
          });

        if (!that.sendCodeActivity) return;

        that.$set(that, "sendCodeText", "发送中");
        that.$set(that, "sendCodeActivity", false);

        var postData = {
          subCode: that.subCode,
          phone: that.mobile,
          code: that.imgCode,
        };
        fetch.post("/wxyx/sendSMS", postData).then(
          (res) => {
            if (res.code == 10007) {
              that.$set(that, "sendCodeActivity", true);
              that.$set(that, "sendCodeText", "发送验证码");
              that.handleUpdateImgCode(); // 更新验证码
              showToast({
                message: res.msg,
                duration: 2000,
              });
            } else if (
              res.code == 10001 ||
              res.code == 10019 ||
              res.code == 10003
            ) {
              that.handleUpdateImgCode(); // 更新验证码
              showToast({
                message: res.msg,
                duration: 2000,
              });
            }
            // 手机验证码发送成功
            if (res.code != 10007) {
              var time = 60;
              var CountDownInterval = setInterval(() => {
                time--;
                that.$set(that, "sendCodeText", `重新发送(${time})`);

                if (time <= 0) {
                  clearInterval(CountDownInterval);
                  that.$set(that, "sendCodeActivity", true);
                  that.$set(that, "sendCodeText", "发送验证码");
                  that.handleUpdateImgCode(); // 更新验证码
                }
              }, 1000);
              if (res.code == 10025) {
                showToast({
                  message: res.msg,
                  duration: 2000,
                });
              }
            }
          },
          (err) => {
            that.handleUpdateImgCode(); // 更新验证码
            // 手机验证码发送失败
            that.$set(that, "sendCodeActivity", true);
            that.$set(that, "sendCodeText", "发送验证码");
            showToast({
              message: err.error_info || err.message,
              duration: 2000,
            });
          }
        );
      } else {
        showToast({
          message: "请填写正确的手机号码",
          duration: 2000,
        });
      }
    },

    //图形验证码
    handleUpdateImgCode() {
      console.log("1111");
      this.$set(
        this,
        "imgCodeSrc",
        `${this.$root.imgCodeBaseURL}/wxyx/valicode?${Math.random()}`
      );
    },

    //登录
    sendInfo() {
      var that = this;
      if (that.submitFlag) {
        if (!that.handleValidate("mobile"))
          return showToast({ message: "请填写正确的手机号码", duration: 1000 });
        if (!that.handleValidate("imgCode"))
          return showToast({
            message: "请填写正确的图形验证码",
            duration: 1000,
          });
        if (!that.handleValidate("mobileCode"))
          return showToast({
            message: "请填写正确的手机验证码",
            duration: 1000,
          });

        var postData = {
          subCode: that.subCode,
          phone: that.mobile,
          inviteCode: that.codes,
          smsCode: that.mobileCode,
        };
        fetch.post("/lcj/acceptInvite", postData).then(
          (res) => {
            if (res.code == 10000) {
              window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html${that.key}`;
              that.clearInfo();
            } else if (res.code == 10039) {
              showToast({
                message: res.error_info || res.message || res.msg,
                duration: 2000,
              });
              console.log("已接受邀请");
              setTimeout(function () {
                window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html${that.key}`;
              }, 2500);
              that.clearInfo();
            } else if (res.code == 10011) {
              showToast({
                message: "您不符合活动参与条件，感谢您的支持！",
                duration: 2000,
              });
              that.clearInfo();
            } else {
              showToast({
                message: res.error_info || res.message || res.msg,
                duration: 2000,
              });
              that.clearInfo();
              that.$set(that, "submitFlag", true);
            }
          },
          (err) => {
            that.clearInfo();
            // 绑定失败
            showToast({
              message: err.error_info || err.message || err.msg,
              duration: 2000,
            });
            that.$set(that, "submitFlag", true);
          }
        );
      } else {
        showToast({
          message: "您操作的太频繁啦",
          duration: 2000,
        });
      }
    },

    clearInfo() {
      //清空信息
      var that = this;
      that.$set(that, "mobile", "");
      that.$set(that, "imgCode", "");
      that.$set(that, "mobileCode", "");
      that.$set(that, "submitFlag", true);
      that.handleUpdateImgCode();

      // eslint-disable-next-line no-undef
      if (CountDownInterval) {
        clearInterval(CountDownInterval);
        that.$set(that, "sendCodeActivity", true);
        that.$set(that, "sendCodeText", "获取验证码");
      }
    },

    formatDate(now) {
      let nowTime = new Date(now);
      var year = nowTime.getFullYear(); //取得4位数的年份
      var month = nowTime.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
      var date = nowTime.getDate(); //返回日期月份中的天数（1到31）
      if (date < 10) {
        date = "0" + date;
      } else {
        date = nowTime.getDate();
      }
      // var hour = nowTime.getHours(); //返回日期中的小时数（0到23）
      // var minute = nowTime.getMinutes(); //返回日期中的分钟数（0到59）
      // var second = nowTime.getSeconds(); //返回日期中的秒数（0到59）
      return year + "." + month + "." + date;
    },

    /**
     * 校验表单信息
     * @param {String} key 需要校验的数据名
     */
    handleValidate(key) {
      if (!key) console.error("需要校验的数据字段不存在!");
      // 校验手机号码
      function ValidateMobile(str) {
        return /^1([0-9][0-9])\d{8}$/.test(str);
      }
      // 校验图形验证码
      function ValidateImgCode(str) {
        return /^(\d|\w)+$/.test(str);
      }
      // 校验手机验证码
      function ValidateMobileCode(str) {
        return /^\d{6}$/.test(str);
      }

      switch (key) {
        case "mobile":
          return ValidateMobile(this.mobile);
        case "imgCode":
          return ValidateImgCode(this.imgCode);
        case "mobileCode":
          return ValidateMobileCode(this.mobileCode.toString());
        default:
          return false;
      }
    },

    // 处理移动端软键盘遮挡输入框
    handleOnFocus() {
      this.$set(this, "userFormFocus", true);
      // document.querySelector("body").setAttribute("style", "position:fixed");
    }, // 输入框丢失焦点
    handleOnBlur() {
      this.$set(this, "userFormFocus", false);
      document.querySelector("body").removeAttribute("style");
      console.log(1111);
      setTimeout(function () {
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 300);
    },
  },
};
</script>

<style lang="less" scoped>
</style>
